import { IRootProps } from "@centraldispatch/singlespa-utilities";
import { HTMLLayoutData } from "single-spa-layout/dist/types/isomorphic/constructRoutes";
import {
  constructApplications,
  constructLayoutEngine,
  constructRoutes,
} from "single-spa-layout";
import microfrontendLayout from "../../microfrontend-layout.html";
import { mountRootParcel, registerApplication, start } from "single-spa";

export interface ISingleSpa {
  start(props: IRootProps): void;
}

export class SingleSpa implements ISingleSpa {
  start(props: IRootProps): void {
    document.querySelectorAll(".root-loader").forEach((e) => e.remove());
    const layoutData = {
      props,
      loaders: {},
    } as HTMLLayoutData;

    const routes = constructRoutes(microfrontendLayout, layoutData);

    const applications = constructApplications({
      routes,
      loadApp({ name }) {
        return System.import(name);
      },
    });

    const layoutEngine = constructLayoutEngine({ routes, applications });

    applications.forEach(registerApplication);
    layoutEngine.activate();
    start();

    System.import("@centraldispatch/navigation").then((module) => {
      const navDom = document.body.querySelector("#navigation") as HTMLElement;
      const footerDom = document.body.querySelector("#footer") as HTMLElement;
      mountRootParcel(module.Navigation, {
        user: props.user,
        authentication: props.authentication,
        domElement: navDom,
      });
      mountRootParcel(module.Footer, { domElement: footerDom });
    });
  }
}
